import { css, type Theme } from "@emotion/react";
import { borders } from "aviary-tokens";

const controlWhite = {
  rest: "rgba(255, 255, 255, 0.45)",
  hover: "rgba(255, 255, 255, 0.7)",
  selected: "rgba(255, 255, 255, 0.95)",
};

const legibilityShadow = "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25))";

export const wrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.small};
`;

export const dotList = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.small};
  margin: 0;
  padding: 0;
  list-style: none;
`;

/* White dots read on the dark slides; the drop shadow keeps them visible on
   the light ones. The selected dot stretches into a vertical pill. */
export const dot = {
  base: css`
    display: block;
    width: 9px;
    height: 9px;
    padding: 0;
    background: ${controlWhite.rest};
    border-radius: ${borders.radiusCircle};
    filter: ${legibilityShadow};
    transition:
      height 240ms ease,
      background 240ms ease;

    &:hover {
      background: ${controlWhite.hover};
    }
  `,
  selected: css`
    height: 26px;
    background: ${controlWhite.selected};
    border-radius: ${borders.radiusPill};

    &:hover {
      background: ${controlWhite.selected};
    }
  `,
};

export const playPauseButton = css`
  flex-shrink: 0;
  filter: ${legibilityShadow};
`;
